import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'dark' | 'light';
};
export function Countdown({
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    v: hours,
    l: 'Hours'
  }, {
    v: minutes,
    l: 'Min'
  }, {
    v: seconds,
    l: 'Sec'
  }];
  const dark = tone === 'dark';
  return <div className="mt-6 text-center" role="timer" aria-live="off" data-id="element-19" data-mp="3c25p13bzrnww">
      <p className={`text-sm font-bold uppercase tracking-wide ${dark ? 'text-cta-300' : 'text-red-600'}`} data-id="element-20" data-mp="3c3z1iz9ad2ct">
        The promotional price expires in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-21" data-mp="324rm86izqxn2">
        {units.map((u, i) => <React.Fragment key={u.l} data-id="element-22" data-mp="373uk970k03lj" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-23" data-mp="374vuxadnqo2q">
              <span className={`flex h-16 w-16 items-center justify-center rounded-xl text-3xl font-extrabold tabular-nums sm:h-[72px] sm:w-[72px] sm:text-4xl ${dark ? 'bg-ink-950 text-white ring-1 ring-white/15' : 'bg-ink-900 text-white'}`} data-id="element-24" data-mp="10dekfqcbl5v8">
                {u.v}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase ${dark ? 'text-mist-300' : 'text-mist-600'}`} data-id="element-25" data-mp="17qzwwc64imvh">
                {u.l}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 text-3xl font-extrabold ${dark ? 'text-white/60' : 'text-ink-900/50'}`} data-id="element-26" data-mp="f1somlgvaix1">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}